import { formatInCompanyTimeZone, getActiveCompanyTimeZone } from "../../../../../helpers/operationalHours";

/**
 * Reservation dates are stored as absolute UTC instants, so rendering them requires choosing a
 * clock. These formatters use the *company's* timezone rather than the admin's browser, so a
 * manager working from another timezone sees the same times the branch does — previously a 9 AM
 * pickup read as 7 PM from Dhaka and looked like it fell outside the configured operational
 * hours. The active zone is set once from company data in `UserContext`.
 */

/** Time of day, e.g. "09:00 AM". */
export const formatDate = (value) => formatInCompanyTimeZone(value, getActiveCompanyTimeZone(), "hh:mm A");

/** Calendar date, e.g. "09/22/2026". */
export const formatDate2 = (value) => formatInCompanyTimeZone(value, getActiveCompanyTimeZone(), "MM/DD/YYYY");

/**
 * Value for a `datetime-local` input.
 *
 * Uses `HH` (24-hour) — the previous `hh` wrote 12-hour digits into a field the browser reads as
 * 24-hour, so any afternoon time loaded into an edit form silently became the morning equivalent
 * (15:30 arrived as "03:30") and saved back that way if the admin did not notice.
 */
export const formatDate3 = (value) =>
    formatInCompanyTimeZone(value, getActiveCompanyTimeZone(), "YYYY-MM-DDTHH:mm");
